module.exports = __webpack_public_path__ + "assets/img/feature-visual-4.8b58c1e4.png";